"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var locale_1 = require("../../locale");

var locale_2 = require("../../util/locale");

var string_1 = require("../../util/string");

var Button_1 = require("../Button");

var Flow_1 = require("../Flow");

var Icon_1 = require("../Icon");

function MonthControl(props) {
  var visibleDate = props.visibleDate,
      onChange = props.onChange,
      renderMonth = props.renderMonth;
  var locale = locale_1.useLocale();

  var handleNext = function handleNext() {
    var next = new Date(visibleDate);
    next.setMonth(visibleDate.getMonth() + 1);
    return onChange(next);
  };

  var handlePrev = function handlePrev() {
    var prev = new Date(visibleDate);
    prev.setMonth(prev.getMonth() - 1);
    return onChange(prev);
  };

  return react_1.default.createElement(Flow_1.HFlow, {
    alignItems: 'center',
    hSpacing: 0.5
  }, react_1.default.createElement(Button_1.Button, {
    title: locale.calendar.previousMonth,
    size: 'small',
    skin: 'ghost',
    onClick: handlePrev,
    tabIndex: -1
  }, react_1.default.createElement(Icon_1.Icon, {
    icon: 'angleLeft'
  })), renderMonth(visibleDate), react_1.default.createElement(Button_1.Button, {
    title: locale.calendar.nextMonth,
    size: 'small',
    skin: 'ghost',
    onClick: handleNext,
    tabIndex: -1
  }, react_1.default.createElement(Icon_1.Icon, {
    icon: 'angleRight'
  })));
}

exports.MonthControl = MonthControl;
MonthControl.defaultProps = {
  renderMonth: function renderMonth(date) {
    var formatter = new Intl.DateTimeFormat(locale_2.getUserLocale(), {
      month: 'short'
    });
    return string_1.capitalize(formatter.format(date));
  }
};